var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-gray-300 min-h-screen h-full px-2 py-10 overflow-y-auto"},[_c('transition',{attrs:{"name":"zoom-fade"}},[(_vm.show)?_c('div',[_c('Form')],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }